import {IsString} from 'class-validator';

export class UserFeedbackDto {
  @IsString()
  content!: string;
}
